import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './shared/styles/main.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import ptBr from 'antd/es/locale/pt_BR';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={ptBr}>
        <App />
      </ConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>
);